import { OnboardingFlowContent } from "./OnboardingFlowLayout";

interface Props {
  children: React.ReactNode;
}

export function OnboardingFlowCard({ children }: Props): React.ReactNode {
  return <OnboardingFlowContent>{children}</OnboardingFlowContent>;
}
